import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect , useState, useContext } from "react";
import {  ExpertStatistics } from "../../../services/kojaServices";
import { Chart } from "react-google-charts";
import { expertContext } from "../../../context/expertcontext";

const Statistics = () => {

  const [info,setInfo] = useState({})
  const [diagram,setDiagram] = useState({})
  const [diagram2,setDiagram2] = useState({})
  const { setPage} = useContext(expertContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("آمار ها")
        const { data } = await ExpertStatistics();
        console.log(data.result);
        setInfo(data.result)
        const diagram =  {
          options: { title: "کارشناسی های انجام شده" },
          data: setData(data.result.finish, "#1EC398"),
        }
        setDiagram(diagram)
        const diagram2 =  {
          options: { title: "درخواست ها" },
          data: setData(data.result.pending, "#1EC398"),
        }
        setDiagram2(diagram2)
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const setData = (data, color) => {
    if (data) {
      let arry = [["date", "value", { role: "style" }]];
      data.map((i) => {
        let showDate = i.fa_date;
        let x = [showDate, i.count, color];
        arry.push(x);
      });
      return arry;
    }
  };
  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div>
        <div className="d-flex my-request-box">
          <Menu />

          <div className="w-100">
            <div className="row w-100 p-3">
              <div className="mb-3 col-md-4" >
                <div className="statistics-box" style={{height:"150px"}}>
                <h5>{info.pending?.length}</h5>
                  <h5>کارشناسی نشده</h5>
                </div>
              </div>
              <div className="mb-3 col-md-4" >
                <div className="statistics-box" style={{height:"150px"}}>
                <h5>{info.finish?.length}</h5>
                  <h5>کارشناسی شده</h5>
                </div>
              </div>
              <div className="mb-3 col-md-4" >
                <div className="statistics-box" style={{height:"150px"}}>
                  <h5>{info.reports}</h5>
                    <h5>شکایات</h5>
                </div>
              </div>
            </div>
            <div className="row p-3">
            <div className="col-lg-6">
            <div className="statistics-box">
            <Chart
            chartType="ColumnChart"
            height="350px"
            width='100%'
            data={diagram.data}
            options={diagram.options}
          />
            </div>
          </div>
              <div className="col-lg-6">
                <div className="statistics-box">
                <Chart
                chartType="ColumnChart"
                width='100%'
                height="350px"
                data={diagram2.data}
                options={diagram2.options}
              />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
